import { useSearch } from '@tanstack/react-router';

import AdGroupDiagnostics from './AdGroupDiagnostics';
import CampaignDiagnostics from './CampaignDiagnostics';

const PacingMetrics = () => {
  const { diagCampaignOrInsertionId } = useSearch({
    from: '/_app/algorithm-tools/starvation-bidder',
  });

  return diagCampaignOrInsertionId ? (
    <AdGroupDiagnostics />
  ) : (
    <CampaignDiagnostics />
  );
};

export default PacingMetrics;
